import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const ReadingProgress = () => {
  const location = useLocation();
  const isArticle = /\/article\//.test(location.pathname);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isArticle) return;
    setProgress(0);
    let raf = 0;
    const update = () => {
      raf = 0;
      const el = document.querySelector('[data-testid="article-page"] article');
      const end = el
        ? el.getBoundingClientRect().bottom + window.scrollY - window.innerHeight
        : document.documentElement.scrollHeight - window.innerHeight;
      setProgress(end > 0 ? Math.min(1, Math.max(0, window.scrollY / end)) : 0);
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [isArticle, location.pathname]);

  if (!isArticle) return null;
  return (
    <div className="absolute bottom-0 left-0 right-0 h-[2.5px] pointer-events-none" data-testid="reading-progress">
      <div
        className="h-full bg-gradient-to-r from-[#7C3AED] to-[#00E5FF] transition-[width] duration-150 ease-out"
        style={{ width: `${progress * 100}%` }}
        data-testid="reading-progress-fill"
      />
    </div>
  );
};
